import axios from '../utils/axios'
// import { SetMarketCooperation } from '../api-interface'

//论文列表接口
export const getTableList = function(data: {
    name: string;  //论文名称
    userIdList: string[]; //产品负责人id
    limit: number; //条数/页
    page: number; //页码
}) { return axios.post('/project/getProjectDissertationList', data) }

//论文查看详情接口
export const getProjectDissertationInfo = function(id: number) {
    return axios.get('/project/getProjectDissertationById?id=' + id)
}

// 论文新增
export const setProjectDissertation = function(data: {
    name: string;  //论文名称
    price: string;  //项目定价
    projectDissertationCostList: { name: string; price: string }[];//项目成本明细
    userId: string; //产品负责人id

}) { return axios.post('/project/setProjectDissertation', data) }

// 论文编辑
export const setProjectDissertationById = function(data: {
    id: number; //论文项目id
    name: string;  //论文名称
    price: string;  //项目定价
    projectDissertationCostList: { name: string; price: string }[];//项目成本明细
    userId: string; //产品负责人id
}) { return axios.post('/project/setProjectDissertationById', data) }


// 论文列表导出
export const projectDissertationExportData = function(data: any) {
    return axios.post('/project/projectDissertationExportData', data)
}



// 上传文件
export const uploadFile = function (data: any) {
    return axios.post('/uploadFile', data)
}
